export default from './Switch';



// WEBPACK FOOTER //
// ./src/sharedComponents/Switch/index.js